import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { AppConfigService } from 'src/app/services/appconfig/app-config.service';
import { catchError, map } from 'rxjs/operators';
import { throwError, Observable } from 'rxjs';
import { AppInsightsService } from 'src/app/services/common/appinsights.service';
import { BillingAdjustmentDetails, InvoiceDetails } from 'src/app/Models/invoiceDetails';
import { Form } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class ApprovalDashBoardService {
  private url: string;
  res: any;

  constructor(appConfigService: AppConfigService,
    private http: HttpClient,
    private appInsights: AppInsightsService) {

    this.url = appConfigService.get('apiUrl');

  }

  getPendingApprovals(request:any): Observable<any> {
    return this.http.post(this.url + '/BillingAdjustment/GetBillingAdjustmentByStatus' ,request).pipe(
      map(response => response as any),
      catchError(response => {
        this.appInsights.logException(response);
        return throwError(response);
      })
    );

  }
  
  getInvoiceDetails(adjReqId: string,adjSubId: number,detailsId: any): Observable<any> {
    return this.http.post(this.url + '/BillingAdjustment/GetBillingAdjustmentDetailsByAdjReqId', {adjReqId,adjSubId,detailsId}).pipe(
      map(response => response as any),
      catchError(response => {
        this.appInsights.logException(response);
        return throwError(response);
      })
    );

  }
  

  UpdateApprovalStatus(adjReqId: string,updatedBy: string, action : number,rejectionReason:string | null | undefined,detailsId: any): Observable<any> {
    const safeRejectionReason = rejectionReason ?? '';
    return this.http.put(this.url + '/BillingAdjustment/UpdateBillingAdjustmentStatus', { adjReqId, action , updatedBy ,rejectionReason: safeRejectionReason,detailsId}).pipe(
      map(response => response as any),
      catchError(response => {
        this.appInsights.logException(response);
        return throwError(response);
      })
    );

  }

  // UpdateApprovalStatusGBS(adjReqId: string,updatedBy: string,statusId : number,reason:string, Inv:number, stmt:number,adjSubId: number): Observable<any> {

  //   return this.http.put(this.url + '/BillingAdjustment/UpdateBillingAdjustmentStatusGBS', { adjReqId, statusId , updatedBy ,reason,Inv,stmt,adjSubId}).pipe(
    UpdateApprovalStatusGBS(requestBody: any): Observable<any> {
      return this.http.put(this.url + '/BillingAdjustment/UpdateBillingAdjustmentStatusGBS', requestBody).pipe(  
      map(response => response as any),
      catchError(response => {
        this.appInsights.logException(response);
        return throwError(response);
      })
    );

  }

  DownloadUploadedFiles(adjReqId: number): Observable<Blob> {
    return this.http.get(this.url + '/BillingAdjustment/DownloadFilesUploaded' + '?AdjReqId=' + adjReqId, {
      responseType: 'blob' 
    }).pipe(
      catchError(response => {
        this.appInsights.logException(response);
        return throwError(response); 
      })
    );
  }

  getBillingAdjustmentsByCloudId(cloudId:string): Observable<any> {
    return this.http.get(this.url + '/BillingAdjustment/GetBillingAdjustmentByCloudId' + '/' + cloudId).pipe(
      map(response => response as any),
      catchError(response => {
        this.appInsights.logException(response);
        return throwError(response);
      })
    );

  }
  
  
  getBillingAdjustmentsByCloudIdDateRange(jsonData: any) {
      return this.http.post(this.url + '/BillingAdjustment/GetBillingAdjustmentByCloudId', jsonData).pipe(
      map(response => <any>response),
      catchError(response => {
        //  console.log(response);
        this.appInsights.logException(response);
        return throwError(response);
      })
    );
  }

  

  getGBSPendingApprovals(jsonData:any): Observable<any> {
    // Add request timestamp for performance monitoring
    const requestStart = performance.now();
    
    return this.http.post(this.url + '/BillingAdjustment/GetBillingAdjustmentForGBS' ,jsonData).pipe(
      map(response => {
        // Log performance metrics
        const duration = performance.now() - requestStart;
        console.log(`GetBillingAdjustmentForGBS API took ${duration.toFixed(2)}ms`);
        
        if (duration > 5000) {
          console.warn(`SLOW API: GetBillingAdjustmentForGBS took ${(duration/1000).toFixed(2)}s`);
        }
        
        return response as any;
      }),
      catchError(response => {
        const duration = performance.now() - requestStart;
        console.error(`GetBillingAdjustmentForGBS API failed after ${duration.toFixed(2)}ms`, response);
        this.appInsights.logException(response);
        return throwError(response);
      })
    );
  }
}

